<template>
        <div class=slideshow-popup :class="{ active : active }">

            <div class=popup-media>

                <InlineVideo v-if="media.video" :video="media.video" :image="media.image" :showControls="true" />

                <img :src="media.image" :alt="media.title">

                <div v-if="hasNav" class=swiper-navigation>

                    <div class=swiper-button-prev @click="$emit('slide-prev')"></div>
                    <div class=swiper-button-next @click="$emit('slide-next')"></div>

                </div>

                <h3 class=slide-title>{{ media.title }}</h3>

            </div>



            <span class=close @click="closePopup"></span>

        </div>
</template>
<script>

import InlineVideo from './InlineVideo.vue';

export default {
    name : 'SlideshowPopup',
    props : {
        active      : Boolean   ,
        hasNav      : Boolean   ,
        type        : String    ,
        media       : Object    ,
        wp          : Boolean   ,
    },
    components : {
        InlineVideo,
    },
    methods : {
        closePopup() {
            this.$emit('close-popup');
        }
    }
}
</script>